import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 600; // Reset loop
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 w-full bg-gradient-to-r from-amber-600 via-yellow-600 to-amber-600 text-black py-3 z-50 shadow-lg shadow-amber-500/50 text-center font-bold text-sm md:text-base tracking-wide" data-id="element-1">
      <div className="container mx-auto px-4 flex justify-center items-center gap-2" data-id="element-2">
        <span data-id="element-3">OFFER ENDS IN:</span>
        <span className="font-mono text-lg" data-id="element-4">{formatTime(timeLeft)}</span>
      </div>
    </div>;
}